<script>
    import PageText from './PageText.svelte';
    import Die from './Die.svelte';
    import pages from './dataImport/spreadsheet.html';
    import Button from './Button.svelte';
    import {hasBackButton, isInterruptionPage, isNormalPage} from './common.js';
    export let state;

    let die = null;

    const buttonInterrupts = () => {
        if (state.interruptions.length > 0) {
            if (isNormalPage(state.pageIndex)) {
                return true;
            } else if (isInterruptionPage(state.pageIndex)) {
                return true;
            }
        } else {
            return false;
        }
    };
    const buttonCount = () => buttonInterrupts() ? 1 : pages[state.pageIndex].choices.length;
    const buttonLayout = () => {
        if (pages[state.pageIndex].dieVisible) {
            return 'centered';
        } else {
            return `count-${buttonCount()}`;
        }
    };
</script>

<style lang="less">
    @import "./common.less";
    div.outer {
        flex: 1 0 auto;
        color: white;
        display: flex;
        flex-direction: row;
        justify-content: center; /* along flex-direction */
        align-items: center; /* perpendicular to flex-direction */
    }
    .desktop({
        @buttonWidth: 31.33%;
        @gutterWidth: 3%;
        @buttonWidth4: 22.74%;
        @halfButton: (@buttonWidth / 2);
        @halfGutter: (@gutterWidth / 2);
        div.buttons {
            text-align: center;
        }
        div.buttons-count-1 {
            text-align: left;
            max-width: @buttonWidth;
        }

        div.buttons-count-2 {
            display: grid;
            grid-template-areas: "n0 . n1 .";
            grid-template-columns: @buttonWidth @gutterWidth @buttonWidth (@gutterWidth + @buttonWidth);
            grid-template-rows: auto;
        }
        div.buttons-count-3 {
            display: grid;
            grid-template-areas: "n0 . n1 . n2";
            grid-template-columns: @buttonWidth @gutterWidth @buttonWidth @gutterWidth @buttonWidth;
            grid-template-rows: auto;
        }
        div.buttons-count-4 {
            display: grid;
            grid-template-areas: "n0 . n1 . n2 . n3";
            grid-template-columns: @buttonWidth4 @gutterWidth @buttonWidth4 @gutterWidth @buttonWidth4 @gutterWidth @buttonWidth4;
            grid-template-rows: auto;
        }
        div.buttons-count-5 {
            display: grid;
            grid-template-areas:
                "n0 n0 . n1 n1 n1 . n2 n2"
                ". n3 n3 n3 . n4 n4 n4 .";
            grid-template-columns: (@halfButton + @halfGutter) (@halfButton - @halfGutter) @gutterWidth (@halfButton - @halfGutter) @gutterWidth (@halfButton - @halfGutter) @gutterWidth (@halfButton - @halfGutter) (@halfButton + @halfGutter);
            grid-template-rows: auto;
        }
    });
    .mobile({
        @buttonWidth: 47.99%;
        @gutterWidth: 4%;
        @halfButton: (@buttonWidth / 2);
        @halfGutter: (@gutterWidth / 2);
        div.buttons {
            text-align: center;
        }
        div.buttons-count-1 {
            text-align: left;
            max-width: 222px;
        }
        div.buttons-count-2 {
            display: grid;
            grid-template-areas: "n0 . n1";
            grid-template-columns: @buttonWidth @gutterWidth @buttonWidth;
            grid-template-rows: auto;
        }
        div.buttons-count-3 {
            display: grid;
            grid-template-areas: "n0 n0 . n1 n1" ". n2 n2 n2 .";
            grid-template-columns: (@halfButton + @halfGutter) (@halfButton - @halfGutter) @gutterWidth (@halfButton - @halfGutter) (@halfButton + @halfGutter);
            grid-template-rows: auto;
        }
        div.buttons-count-4 {
            display: grid;
            grid-template-areas: "n0 . n1" "n2 . n3";
            grid-template-columns: @buttonWidth @gutterWidth @buttonWidth;
            grid-template-rows: auto;
        }
        div.buttons-count-5 {
            display: grid;
            grid-template-areas: "n0 n0 . n1 n1" "n2 n2 . n3 n3" ". n4 n4 n4 .";
            grid-template-columns: (@halfButton + @halfGutter) (@halfButton - @halfGutter) @gutterWidth (@halfButton - @halfGutter) (@halfButton + @halfGutter);
            grid-template-rows: auto;
        }
    });
    div.pageAndButtonsInner {
        width: 700px;
        max-width: 100%;
        flex: 0 1 700px;
        padding-left: 20px;
        padding-right: 20px;
    }
</style>

<div class="outer">
    <div class="pageAndButtonsInner">
        {#key state}
            {#if pages[state.pageIndex].dieVisible}
                <Die bind:this={die} rolling={pages[state.pageIndex].dieRolling ? true : false} value={state.dieValue}/>
            {/if}
            <PageText lines={pages[state.pageIndex].lines} {state}/>
            {#if !pages[state.pageIndex].dieRolling}
                <div class="buttons buttons-{buttonLayout()}">
                    {#if (buttonInterrupts())}
                        <Button style="display: inline-block; padding: 17px; margin-top: 20px" message={{dest: 'interrupt'}}><PageText lines={["Continue"]} {state}/></Button>
                    {:else}
                        {#each pages[state.pageIndex].choices as choice, i}
                            <Button style="{buttonCount() === 1 ? 'display: inline-block' : `grid-area: n${i}`}; padding:17px; margin-top: 20px" message={choice}><PageText lines={choice.text.split("\n\n")} {state}/></Button>
                        {/each}
                    {/if}
                </div>
            {/if}
        {/key}
    </div>
</div>